import Carousel from 'react-bootstrap/Carousel';
import posterthree from "../../images/stree_banner_one.jpeg"
import posterone from "../../images/stree_banner_two.jpeg"
import postertwo from "../../images/stree_banner_three.jpeg"
function IndividualIntervalsExample() {
  return (
    <div id='home' className='slider-container'>
    <Carousel variant="dark" >
      <Carousel.Item interval={3000} style={{zIndex:-2}} >
        <img
          className="d-block w-100"
          
          src={posterone}
          alt="First slide"
          
        />
        
      </Carousel.Item>
      <Carousel.Item interval={3000} style={{zIndex:-2}}>
        <img
          className="d-block w-100"
          src={postertwo}
          alt="Second slide"
        />
        
      </Carousel.Item>
      <Carousel.Item interval={3000} style={{zIndex:-2}}>
        <img
          className="d-block w-100"
          src={posterthree}
          alt="Third slide"
        />
       
      </Carousel.Item>
    </Carousel>
    </div>
  );
}

export default IndividualIntervalsExample;